import { useCallback } from 'react';
import type { ElasticRetailer } from '@//app/api/retailers/[slug]';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackMailSentRetailerEventData } from './legacy-types';

export const createLegacyTrackMailSentRetailer = (
  branch: ElasticRetailer,
): LegacyTrackMailSentRetailerEventData => {
  const eventData: LegacyTrackMailSentRetailerEventData = {
    eventType: 'other',
    conversionType: 'mail-sent-retailer',
    branch: {
      id: branch.id,
    },
    pageType: 'dealer page',
  };

  return eventData;
};

export const useLegacyTrackMailSentRetailer = () => {
  const { track } = useLegacyTracking();

  const trackLegacyTrackMailSentRetailer = useCallback(
    (branch: ElasticRetailer) => {
      track({
        event: 'other',
        data: createLegacyTrackMailSentRetailer(branch),
      });
    },
    [track],
  );

  return {
    trackLegacyTrackMailSentRetailer,
  };
};
